import ApiService from '@/core/api/api.service';
import loginService from '@/modules/users/services/login.service';

export default class AuthService extends ApiService {
  async login(payload) {
    try {
      this.loader = true;
      this.url = process.env.VUE_APP_API_AUTH_URL;
      this.payload = {
        grant_type: 'password',
        // eslint-disable-next-line radix
        client_id: parseInt(process.env.VUE_APP_CLIENT_ID),
        client_secret: process.env.VUE_APP_CLIENT_SECRET,
        username: payload.email,
        password: payload.password,
      };

      const result = await this.post();
      if (result) {
        this.setAccessToken(result);
        return result;
      }
    } catch (error) {
      return error;
    }
    return false;
  }

  getAccessToken = () => localStorage.getItem(process.env.VUE_APP_TOKEN_NAME)

  getRefreshToken = () => localStorage.getItem('refresh_token')

  setAccessToken = (result) => {
    localStorage.setItem(process.env.VUE_APP_TOKEN_NAME, `Bearer ${result.access_token}`);
    localStorage.setItem('refresh_token', `${result.refresh_token}`);
    loginService(result);
  }
}
